import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "video-play",
  "use": "video-play-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"video-play\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 2a1 1 0 00-1 1v10a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1H1zm5.393 2.775A.25.25 0 006 4.98v6.04c0 .202.228.32.393.205L11 8 6.393 4.775z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol